let reportIdentifier = {
    $buttonReport: $('.js-reportIdentifierButtonReport'),
    $continue: $('#js-reportIdentifierExplanations'),
    $el: $('#js-reportIdentifier'),
    $explanations: $('#js-reportIdentifierExplanations'),
    $form: $('#js-reportIdentifierForm'),
    $options: $('.js-reportIdentifierOption'),
    $reportForm: $('#js-reportForm'),
    classNameIsChecked: 'is-checked',
    classNameOption: 'js-reportIdentifierOption',

    init() {
        $('input', this.$options).on('change', (e) => {
            this.$options.removeClass(this.classNameIsChecked)
            $(e.currentTarget).closest(`.${this.classNameOption}`).addClass(this.classNameIsChecked)
        })

        this.$form.on('ajaxForm:success', (e, response) => {
            if (response.id == 6) {
                this.$el.hide()
                this.$reportForm.show()
            } else {
                this.$form.hide()
                this.$explanations.attr('data-identifier-explanation', response.id)
            }
        })

        this.$buttonReport.on('click', (e) => {
            this.$el.hide()
            this.$reportForm.show()
        })
    }
}

export default reportIdentifier